import { useLayoutEffect, useState } from "react";
export const useModalScroll = ({ ref, footer, children, isOpen, }) => {
    const [isScrollable, setIsScrollable] = useState(false);
    const [scrollWidth, setScrollWidth] = useState(14);
    useLayoutEffect(() => {
        if (ref && ref.current) {
            setIsScrollable(ref.current.clientHeight < ref.current?.scrollHeight);
            setScrollWidth(ref.current.offsetWidth - ref.current.clientWidth);
        }
    }, [ref, isOpen, footer, children]);
    return {
        isScrollable,
        scrollWidth,
    };
};
